import { render, staticRenderFns } from "./broadcastingAgreement.vue?vue&type=template&id=6ffd4e68&scoped=true&"
import script from "./broadcastingAgreement.vue?vue&type=script&lang=js&"
export * from "./broadcastingAgreement.vue?vue&type=script&lang=js&"
import style0 from "./broadcastingAgreement.vue?vue&type=style&index=0&id=6ffd4e68&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffd4e68",
  null
  
)

export default component.exports